import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import {
  coverOf,
  formatPrice,
  pickLatestProjects,
  productPath,
} from '../productHelpers';
import './HomeSections.css';

const COUNT = 6;

const Cover = ({ product }) => {
  const [failed, setFailed] = useState(false);
  const src = coverOf(product, 800);

  if (!src || failed) {
    return (
      <span className="hs-pcard__img hs-pcard__img--empty" aria-hidden="true">
        {(product.name || '?').charAt(0)}
      </span>
    );
  }

  return (
    <img
      className="hs-pcard__img"
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};

const LatestProjects = ({ products = [], totalCount, isLoading = false }) => {
  const latest = useMemo(() => pickLatestProjects(products, COUNT), [products]);
  const total = Math.max(Number(totalCount) || 0, products.length);

  if (!latest.length && !isLoading) return null;

  return (
    <section className="hs" aria-labelledby="hs-latest-title">
      <div className="hs__inner">
        <div className="hs__head">
          <h2 id="hs-latest-title" className="hs__title">
            Latest projects
          </h2>
          {total > 0 && (
            <Link className="hs__link" to="/products">
              View all {total}
              <ArrowRight aria-hidden="true" />
            </Link>
          )}
        </div>

        <ul className="hs-grid hs-grid--shots">
          {latest.length
            ? latest.map(product => (
                <li key={product.id}>
                  <Link className="hs-pcard" to={productPath(product)}>
                    <span className="hs-pcard__media">
                      <Cover product={product} />
                    </span>
                    <span className="hs-pcard__body">
                      <span className="hs-pcard__name">{product.name}</span>
                      <span className="hs-pcard__price">
                        {formatPrice(product.price)}
                      </span>
                    </span>
                    {product.category && (
                      <span className="hs-pcard__cat">{product.category}</span>
                    )}
                  </Link>
                </li>
              ))
            : Array.from({ length: COUNT }, (_, i) => (
                <li key={i} aria-hidden="true">
                  <span className="hs-pcard__media hs-skel" />
                </li>
              ))}
        </ul>
      </div>
    </section>
  );
};

export default LatestProjects;
